import axios from 'axios';
import { handleAuthError } from '../funciones/authHelper';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchOficinaData = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/api/oficina/${id}`, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchOficinasData = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/oficinas`, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`,
            'Cache-Control': 'no-cache'
        }});
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchOficinasFiltersData = async (paginaActual, registrosPorPag, busqueda, ordenarColumna, orden) => {
    try {
        const response = await axios.post(`${API_URL}/api/oficinas/filters`, {
            "current_page": paginaActual,
            "items_per_page": registrosPorPag,
            "nombre": busqueda,
            "ordenarColumna": ordenarColumna || "",
            "orden": orden || ""
        }, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});

        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchEliminarOficina = async (id) => {
    try {
        const response = await axios.delete(`${API_URL}/api/oficina/${id}`, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchCrearOficina = async (oficinaData) => {
    try {
        const response = await axios.post(`${API_URL}/api/oficina`, oficinaData, {headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchEditarOficina = async (id, oficinaData) => {
    try {
        const response = await axios.put(`${API_URL}/api/editarOficina/${id}`, oficinaData, {headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};